module.exports = __webpack_public_path__ + "static/woodenblocks-8c6b10edf48cf5872bc3475ef7b91bba.png";